module.exports = __webpack_public_path__ + "images/logo-env_qa.svg?387d57899164f7651043e0a2095f002d";